import {Module} from '@mamdev/cad.static-next-lib';
import Viewport from '../../ts/services/viewport';

/**  The Table of Contents (toc), for the Route Planner & Public Persons */
export default class ToC extends Module {
  private scrollOffset: number;

  /** Init. from DOM. */
  static attachTo(root: HTMLElement): ToC {
    return new ToC(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'toc';
    this.scrollOffset = 50; // Fixed distance (e.g. Stickybar), when scroll headlines this must be taken into account
  }

  /** Start the module. */
  start() {
    if (Viewport.matches('desktop')) {
      this.scrollOffset = 115;
    }

    this.onClickAnchorSmoothScroll();
  }

  /**  Apply smooth scroll to table of content anchors */
  onClickAnchorSmoothScroll() {
    const anchors = this.root_.querySelectorAll<HTMLAnchorElement>('.list.master a');

    anchors.forEach(anchor => {
      anchor.addEventListener('click', e => {
        const eventTarget = e.target as HTMLAnchorElement;
        if (!eventTarget?.href) return;

        e.preventDefault();
        e.stopPropagation();

        const idOfTarget = anchor.hash;
        const target = document.querySelector(idOfTarget);

        if (target) {
          Viewport.scrollViewPortTo(target, this.scrollOffset);
        }
      });
    });
  }
}
